import { Controller } from "@hotwired/stimulus"

// Mirrors an input's value into a list-item's visible label as you type — so editing a website in the
// modal updates the label shown in the list. Prefers the optional `source` (the name field) and falls
// back to `fallback` (the URL) when the name is blank, matching the server's display_name. (Lighter than
// modal-edit, which also manages a visible/hidden toggle these items don't have.)
export default class extends Controller {
  static targets = ["label", "source", "fallback"]
  static values = { placeholder: { type: String, default: "" } }

  update() {
    const name = this.hasSourceTarget ? this.sourceTarget.value?.trim() : ""
    const fallback = this.hasFallbackTarget ? this.fallbackTarget.value?.trim() : ""
    this.labelTarget.textContent = name || fallback || this.placeholderValue
  }
}
